import React, { FC } from 'react';
import cn from 'clsx';
import { gql } from '@apollo/client';

import AppLink from '../AppLink';
import LazyImage from '../LazyImage';
import SlatButton, { UNDERLINE_BUTTON_TYPE, BLACK_BUTTON_COLOR, LARGE_SIZE } from '../SlatButton';

import useBlogPostsQuery from '../../hooks/useBlogPostsQuery';
import unescape from '../../utils/unescape';

const BLOG_POSTS_QUERY = gql`
  query getQuery($tags: [String]!) {
    blogPosts(tags: $tags) {
      embedded
      id
      link
      title
    }
  }
`;

const BlogPosts: FC<any> = ({ className, tags, tracking }) => {
  const { error, loading, posts } = useBlogPostsQuery(tags, BLOG_POSTS_QUERY);

  if (loading || error) {
    return null;
  }

  return (
    <div className={cn(className, 'text-lapel')}>
      <h3 className="heading-xsmall md:heading-small 2xl:heading-medium mb-4 md:mb-6">
        See what&apos;s inspiring us:
      </h3>
      <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
        {posts.map((post: any) => {
          const { id, link } = post;
          const title = unescape(post.title?.rendered);

          const image =
            post.embedded['wp:featuredmedia'][0]?.mediaDetails?.sizes?.medium?.sourceUrl;

          return (
            <AppLink
              className="flex flex-row space-x-4 lg:space-x-8 items-center w-full"
              href={link}
              key={id}
              tracking={{ ...tracking, id: title }}
            >
              <LazyImage
                alt={unescape(title)}
                aspectRatio="66.7%"
                className="w-1/2"
                image={image}
                imageClassName="w-full"
              />
              <div className="w-1/2">
                <h3 className="paragraph-small leading-4 font-medium md:paragraph-serif-large xl:paragraph-serif-xlarge mb-2 md:mb-4">
                  {unescape(title)}
                </h3>
                <SlatButton
                  as="span"
                  color={BLACK_BUTTON_COLOR}
                  size={LARGE_SIZE}
                  type={UNDERLINE_BUTTON_TYPE}
                >
                  Read on the blog
                </SlatButton>
              </div>
            </AppLink>
          );
        })}
      </div>
    </div>
  );
};

export default BlogPosts;
